<template>
  <div
    class="container"
    :style="{
      background:
        'url(' +
        require('../../assets/img/' + bei_ing) +
        ') no-repeat center center',
      'background-size': '100% 100%',
    }"
  >
    <dingbu @cart-tatus="cartTatus"></dingbu>
    <div class="home_content" style="min-height: 600px">
      <div class="bg_color">
        <div class="w">
          <div class="inform__box">
            <div class="box__top">
              <span class="shou__ye">首页</span>
              <span>
                <img class="img__o" src="../../assets/xiangyou (2).png" alt />
              </span>
              <span class="ton__zhi">我的订单</span>
            </div>
          </div>

          <div class="box__meorder">
            <div class="histoy" v-for="(item, index) in list" :key="index">
              <div class="data_date">{{ item.pay_date }}</div>
              <div class="store__box">
                <img :src="item.image" alt="" />
                <div class="rig_box">
                  <div class="big_title_money">
                    <div class="big__title">{{ item.examname }}</div>
                    <div class="big__money">
                      <span class="money_name">购买金额：</span>
                      <span class="money_count">{{ item.study_price }}元</span>
                    </div>
                  </div>
                  <div class="small_title_money">
                    <div class="small__title">{{ item.class_hour }} 课时</div>
                    <div class="small__money">
                      <span class="icon_money_name">购买时间：</span>
                      <span class="icon_money_count">{{ item.pay_time }}</span>
                    </div>
                  </div>
                  <div class="down_text">
                    <div class="small__title">
                      <img src="../../assets/img/jin_10.png" alt="" />
                      <div class="start_time">
                        起止时间：{{ item.start_time }}-{{ item.end_time }}
                      </div>
                    </div>
                    <div class="kai__piao" v-if="item.invoice_status != 0">
                      已申请发票
                    </div>
                    <div
                      class="kai__piao"
                      v-else
                      @click.stop="comeInApply(item.id)"
                    >
                      申请开票
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <dibu></dibu>
    <daohan></daohan>
  </div>
</template>

<script>
import daohan from "../daohan";
import dibu from "../dibu";
import dingbu from "../dingbu";
export default {
  components: {
    daohan,
    dibu,
    dingbu
  },
  data() {
    return {
      bei_ing: this.Public.bei_ing,
      addki: [],
      page: 1,
      pageNum: 10,
      total: 1,
      list: [],
    };
  },
  mounted() {

  },
  created() {
    this.getMeorder()
    // console.log('weoiruqwoeiruio');
  },
  methods: {
    cartTatus(val) {
      this.addki = val.info
      this.total = val.total_num
    },
    async getMeorder() {   // 我的订单
      let that = this, url = 'user/studyPayLog', param = {
        page: this.page,
        pageNum: this.pageNum
      }
      try {
        const { data } = await this.post(url, param)
        // console.log(data);
        this.total = data.total
        this.list = [...this.list, ...data.data]
      } catch (err) {
        // console.log(err);
        that.$message.error(err.data.msg)
      }
    },
    comeInApply(id) {
      this.$router.push({ path: '/applyInvoicing', query: { id: id } })
    },
  },
};
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #198bf8 !important;
  color: #fff;
  border-radius: 50%;
}
.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  background-color: #ffffff;
  color: #06121e;
  min-width: 30px;
  border-radius: 2px;
}
</style>
<style scoped lang="less">
@import "../../css/policy.css";

.box__meorder {
  width: 100%;
  background: #ffffff;
  padding: 28px 41px 54px 29px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 400px;
  margin-bottom: 40px;

  .histoy {
    width: 100%;
    border: 1px solid #eee;
    box-sizing: border-box;

    .data_date {
      width: 100%;
      height: 40px;
      font-size: 14px;
      font-family: Source Han Sans CN, Source Han Sans CN-Regular;
      font-weight: 600;
      text-align: left;
      color: #06121e;
      line-height: 40px;
      padding: 0 24px;
      box-sizing: border-box;
      background-color: #eaeaea;
    }

    .store__box {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 16px;
      box-sizing: border-box;

      img {
        width: 135px;
        height: 88px;
        border-radius: 8px;
      }

      .rig_box {
        flex: 1;
        padding-left: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .big_title_money,
        .small_title_money,
        .down_text {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .big__title {
            flex: 1;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 600;
            text-align: left;
            color: #06121e;
          }
          .small__title {
            font-size: 14px;
            font-family: Source Han Sans CN, Source Han Sans CN-Regular;
            font-weight: 400;
            text-align: left;
            color: #707070;
          }

          .small__title {
            display: flex;
            align-items: center;
            height: 30px;

            img {
              width: 16px;
              height: 16px;
            }

            .start_time {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              margin-left: 8px;
            }
          }

          .kai__piao {
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            font-family: Source Han Sans CN, Source Han Sans CN-Medium;
            font-weight: 500;
            text-align: left;
            color: #3e8bff;
            height: 30px;
          }

          .big__money,
          .small__money {
            width: 160px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .money_name {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
            }
            .money_count {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Medium;
              font-weight: 600;
              text-align: left;
              color: #ff1027;
            }

            .icon_money_name .icon_money_count {
              font-size: 14px;
              font-family: Source Han Sans CN, Source Han Sans CN-Regular;
              font-weight: 400;
              text-align: left;
              color: #06121e;
              margin-right: 16px;
            }
          }
        }
      }
    }
  }
}
</style>